import React, { Component, Fragment } from 'react';
import { getBrandsAndJurisdictions } from '../../../../../../../jurisdiction/redux/selectors';
import { connect } from 'react-redux';
import {
    addJurisdictionToTeam,
    deleteJurisdictionFromTeam
} from '../../../redux/jurisdictions/actions';
import * as _ from 'lodash';
import { ContentBox } from '../../../../../../../shared/content-box/ContentBox';
import { LabeledCheckbox } from '../../../../../../../shared/labeled-checkbox/LabeledCheckbox';
import { RadioOptions } from '../../../../../../../shared/radio-options/RadioOptions';
import {
    getTeamAddBrandLoading,
    getTeamAddJurisdictionLoading
} from '../../../redux/jurisdictions/selector';
import { JurisdictionMode } from '../TeamJurisdictions';
import { isSandboxJurisdiction } from '../../../../../../../shared/models/jurisdictions';
import { SandboxNote } from '../../../../../../../shared/sandbox/SandboxNote';

class JurisdictionsSelect extends Component {
    jurisdictionRadioOptions = [
        { name: 'All Jurisdictions', value: JurisdictionMode.All },
        { name: 'No Jurisdictions', value: JurisdictionMode.None },
        { name: 'Custom', value: JurisdictionMode.Custom }
    ];

    constructor(props) {
        super(props);

        this.state = {
            jurisdictionMode: this.getJurisdictionMode(props.teamJurisdictions)
        };
    }

    hasAllJurisdictions = jurisdictions =>
        !!jurisdictions.find(code => code === JurisdictionMode.All);

    getJurisdictionMode = teamJurisdictions => {
        const jurisdictions = this.getTeamJurisdictionCodes();
        if (!jurisdictions) {
            _.isFunction(this.props.isInCustomMode) &&
                this.props.isInCustomMode(true);
            return JurisdictionMode.Custom;
        }

        if (this.hasAllJurisdictions(jurisdictions)) {
            _.isFunction(this.props.isInCustomMode) &&
                this.props.isInCustomMode(false);
            return JurisdictionMode.All;
        } else if (teamJurisdictions.length === 0) {
            _.isFunction(this.props.isInCustomMode) &&
                this.props.isInCustomMode(false);
            return JurisdictionMode.None;
        } else if (teamJurisdictions.length > 0) {
            _.isFunction(this.props.isInCustomMode) &&
                this.props.isInCustomMode(true);
            return JurisdictionMode.Custom;
        }
    };

    getTeamJurisdictionCodes = () => {
        const { teamJurisdictions } = this.props;

        return (teamJurisdictions || []).map(jurisdiction => jurisdiction.code);
    };

    handleJurisdictionModeChange = jurisdictionMode => {
        this.setState(
            {
                ...this.state,
                jurisdictionMode
            },
            () => this.addJurisdiction()
        );
    };

    addJurisdiction = jurisdictionCode => {
        const { jurisdictionMode } = this.state;
        const {
            addJurisdiction,
            teamId,
            isInCustomMode,
            teamJurisdictions
        } = this.props;

        if (jurisdictionMode === JurisdictionMode.All) {
            _.isFunction(isInCustomMode) && isInCustomMode(false);
            _.isFunction(addJurisdiction) &&
                addJurisdiction(teamId, [
                    {
                        code: JurisdictionMode.All,
                        brandIds: [JurisdictionMode.All]
                    }
                ]);
        } else if (jurisdictionMode === JurisdictionMode.None) {
            _.isFunction(isInCustomMode) && isInCustomMode(false);
            _.isFunction(addJurisdiction) && addJurisdiction(teamId, []);
        } else if (jurisdictionMode === JurisdictionMode.Custom) {
            _.isFunction(isInCustomMode) && isInCustomMode(true);

            if (jurisdictionCode) {
                _.isFunction(addJurisdiction) &&
                    addJurisdiction(teamId, [
                        ...teamJurisdictions,
                        {
                            code: jurisdictionCode,
                            brandIds: [JurisdictionMode.All]
                        }
                    ]);
            }
        }
    };

    deleteJurisdiction = jurisdictionCode => {
        const { teamId, deleteJurisdiction } = this.props;

        _.isFunction(deleteJurisdiction) &&
            deleteJurisdiction(teamId, jurisdictionCode);
    };

    handleJurisdictionCodeChange = jurisdictionCode => {
        if (this.isJurisdictionSelected(jurisdictionCode)) {
            this.deleteJurisdiction(jurisdictionCode);
        } else {
            this.addJurisdiction(jurisdictionCode);
        }
    };

    isJurisdictionSelected = code => {
        const teamJurisdictions = this.getTeamJurisdictionCodes();

        if (this.hasAllJurisdictions(teamJurisdictions)) {
            return true;
        }
        return !!this.getTeamJurisdictionCodes().find(
            currCode => currCode === code
        );
    };

    showJurisdictionSelection = () =>
        this.state.jurisdictionMode === JurisdictionMode.Custom;

    /* Two sandboxes copied from the same jurisdiction have the same name, so a sandbox is told by its code too. */
    getJurisdictionText = jurisdiction =>
        isSandboxJurisdiction(jurisdiction)
            ? `${jurisdiction.name} - ${jurisdiction.code}`
            : jurisdiction.name;

    render() {
        const { jurisdictions, jurisdictionLoading, brandLoading } = this.props;
        const isLoading = jurisdictionLoading || brandLoading;

        return (
            <div className={'jurisdictions-select-container'}>
                <ContentBox
                    title={'Jurisdictions'}
                    content={
                        <Fragment>
                            <div className={'jurisdiction-select-row'}>
                                <RadioOptions
                                    disabled={isLoading}
                                    handleChange={
                                        this.handleJurisdictionModeChange
                                    }
                                    value={this.state.jurisdictionMode}
                                    options={this.jurisdictionRadioOptions}
                                />

                                {this.showJurisdictionSelection() &&
                                    jurisdictions && (
                                        <div>
                                            {jurisdictions.map(jurisdiction => (
                                                <LabeledCheckbox
                                                    key={jurisdiction.code}
                                                    text={this.getJurisdictionText(
                                                        jurisdiction
                                                    )}
                                                    disabled={isLoading}
                                                    onChange={() =>
                                                        this.handleJurisdictionCodeChange(
                                                            jurisdiction.code
                                                        )
                                                    }
                                                    checked={this.isJurisdictionSelected(
                                                        jurisdiction.code
                                                    )}
                                                />
                                            ))}
                                        </div>
                                    )}
                            </div>
                            {this.state.jurisdictionMode ===
                                JurisdictionMode.All &&
                                _.some(
                                    jurisdictions,
                                    isSandboxJurisdiction
                                ) && (
                                    <SandboxNote>
                                        All Jurisdictions does not include the
                                        sandboxes. To give a team access to one,
                                        choose Custom.
                                    </SandboxNote>
                                )}
                        </Fragment>
                    }
                />
            </div>
        );
    }
}
const mapStateToProps = state => {
    const { jurisdictions } = getBrandsAndJurisdictions(state);

    return {
        jurisdictions,
        jurisdictionLoading: getTeamAddJurisdictionLoading(state),
        brandLoading: getTeamAddBrandLoading(state)
    };
};
const mapDispatchToProps = dispatch => ({
    addJurisdiction: (teamId, jurisdictions) =>
        dispatch(addJurisdictionToTeam({ teamId, jurisdictions })),
    deleteJurisdiction: (teamId, jurisdictionCode) =>
        dispatch(deleteJurisdictionFromTeam({ teamId, jurisdictionCode }))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(JurisdictionsSelect);
